import { defineComponent } from 'vue';
import { DateRange } from '@/type';
import moment from 'moment';
import DatePickerMixin from './DatePickerMixin';

interface Data {
  mode: string,
}

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [DatePickerMixin],
  props: {
    modelValue: Object as () => DateRange,
  },
  data(): Data {
    return {
      mode: 'range',
    };
  },
  computed: {
    humanValue(): string|null {
      if (!this.modelValue || !this.modelValue.start || !this.modelValue.end) return null;
      return `${this.formatValue(this.modelValue.start)} - ${this.formatValue(this.modelValue.end)}`;
    },
    defaultValue(): string[] {
      if (!this.modelValue) return [];
      return [
        this.modelValue.start,
        this.modelValue.end,
      ];
    },
  },
  methods: {
    onChange(dates: string[]) {
      if (!dates.length) {
        this.$emit('update:modelValue', null);
      } else if (dates.length === 2) {
        const [start, end] = dates;
        this.$emit('update:modelValue', {
          start: moment(start).format('YYYY-MM-DD'),
          end: moment(end).format('YYYY-MM-DD'),
        });
      }
    },
  },
});
